import { compact, map, filter, every, isEmpty, some, get, toLower } from 'lodash'

const filteredCertsData = ({ certs: certAssets, filters }) => filter(certAssets, asset => {
    const filterResults = {}
    if (filters.expiresIn != 'All') {
      filterResults['expiresIn'] = some(filters.expiresIn, lastSeen => (
        get(asset, 'expires_in_days') >= lastSeen.value[0] && get(asset, 'expires_in_days') <= lastSeen.value[1]
      ))
    }

    return (every(filterResults, (value, key) => value === true) || isEmpty(filterResults))

  })

export default filteredCertsData
export { filteredCertsData }
